import { FC } from 'react';
import { Stack } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { Reservation } from '@mews-commander/data-access';
import { LocalizedDateFromUtc, SpacedDash, SpacedPipe } from '@mews-commander/ui';
import { getCurrentEnterpriseReservationsByIds } from '@mews-commander/legacy-entities/src/selectors/reservations';
import { useCommanderSelector } from '@mews-commander/utils';
import { CustomerName, ResourceCategoryName, ServiceName } from '../../../../components';
import { ResourceName } from '../../../../components/reservation/ResourceName';

interface AffectedReservationsProps {
    reservationIds: string[];
}

export const AffectedReservations: FC<AffectedReservationsProps> = ({ reservationIds }: AffectedReservationsProps) => {
    const reservations = useCommanderSelector((state) =>
        getCurrentEnterpriseReservationsByIds(state, { ids: reservationIds })
    );

    return (
        <Stack vertical spacing="50">
            {reservations.map((reservation) => (
                <AffectedReservation key={reservation.id} reservation={reservation} />
            ))}
        </Stack>
    );
};

interface AffectedReservationProps {
    reservation: Reservation;
}

const AffectedReservation: FC<AffectedReservationProps> = ({ reservation }: AffectedReservationProps) => {
    const { ownerId, requestedCategoryId, serviceId, assignedResourceId, startedUtc, startUtc, endUtc, number } =
        reservation;

    return (
        <div>
            <CustomerName id={ownerId} />
            {SpacedDash}
            <ResourceCategoryName id={requestedCategoryId} serviceId={serviceId} />
            {UnicodeEntity.NoBreakSpace}
            {assignedResourceId && <ResourceName resourceId={assignedResourceId} />}
            {SpacedPipe}
            <LocalizedDateFromUtc utcString={startedUtc || startUtc} />
            {SpacedDash}
            <LocalizedDateFromUtc utcString={endUtc} />
            {SpacedDash}
            <ServiceName id={serviceId} />
            {UnicodeEntity.NoBreakSpace}
            {number}
        </div>
    );
};
